module.exports = __webpack_public_path__ + "img/TradingView-img9.d8ea8346.png";